/* Source-choice only. Existing PDP / Mayfair controllers retain playback ownership. */
(function () {
  'use strict';
  if (window.csDonnaVideoQuality) return;
  var states = new WeakMap();
  var activeOriginal = null;
  function attach(video, options) {
    if (!video || !video.hasAttribute('data-cs-donna-quality')) return null;
    if (states.has(video)) return states.get(video);
    var opts = options || {}, listeners = [], timer = null;
    var resolved = false, failed = false, original = false, disposed = false, pending = false;
    var resumeAt = 0, generation = 0, fallingBack = false, sourcePausePending = false;
    var sources = Array.from(video.querySelectorAll('source')).map(function (s) {
      var url = s.getAttribute('src') || s.dataset.dnSrc || '';
      var encodedHeight = url.match(/(?:HD|SD)-(\d+)p-/);
      return { url: url, type: s.type || '', width: Number(s.dataset.width) || 0, height: Number(s.dataset.height) || (encodedHeight ? Number(encodedHeight[1]) : 0) };
    }).filter(function (s) { return s.url; });
    var adaptive = sources.find(function (s) { return /mpegurl/i.test(s.type) && video.canPlayType(s.type); });
    var standard = adaptive || sources.filter(function (s) { return /mp4/i.test(s.type); }).sort(function (a, b) { return b.height - a.height; })[0] || sources[0];
    var master = video.dataset.csMaster || '';
    if (!/^https:\/\/cdn\.shopify\.com\/videos\/c\/o\/v\/[a-f0-9]{32}\.mp4$/.test(master)) master = '';
    // Set the approved cover without loading or starting the video.
    var poster = video.dataset.csPoster;
    if (poster && /^https:\/\/cdn\.shopify\.com\//.test(poster)) {
      video.poster = poster;
      if (opts.posterElement) { opts.posterElement.removeAttribute('srcset'); opts.posterElement.src = poster; }
    }
    var stop = function () { clearTimeout(timer); timer = null; pending = false; if (activeOriginal === video) activeOriginal = null; };
    var allowed = function () { return !disposed && video.isConnected && !document.hidden && (!opts.canRetry || opts.canRetry()); };
    function listen(name, fn) { video.addEventListener(name, fn); listeners.push([name, fn]); }
    function setSource(url, useOriginal) {
      stop(); generation++;
      resumeAt = video.currentTime || resumeAt;
      if (opts.beforeSwitch) opts.beforeSwitch();
      sourcePausePending = !video.paused;
      original = useOriginal;
      video.dataset.csQuality = useOriginal ? 'original' : 'standard';
      video.src = url;
      video.load();
    }
    function fallback() {
      if (!original || failed || !standard || disposed) return false;
      failed = true;
      fallingBack = true;
      setSource(standard.url, false);
      var expected = generation;
      requestAnimationFrame(function () {
        fallingBack = false;
        if (expected === generation && allowed() && opts.retry) opts.retry();
      });
      return true;
    }
    function watch() {
      clearTimeout(timer); timer = null;
      if (!original || failed || !allowed() || (!pending && video.paused)) return;
      var expected = generation;
      timer = setTimeout(function () {
        timer = null;
        if (expected === generation && allowed() && (pending || !video.paused)) fallback();
      }, 6000);
    }
    function prepare() {
      if (resolved || disposed) return;
      resolved = true;
      if (!standard) return;
      var connection = navigator.connection;
      var width = Number(video.dataset.csOriginalWidth), height = Number(video.dataset.csOriginalHeight);
      var codec = video.dataset.csOriginalCodec || '';
      var standardWidth = Number(video.dataset.csStandardWidth) || Math.max.apply(Math, sources.map(function (s) { return s.width; })) || 606;
      var neededWidth = video.getBoundingClientRect().width * (window.devicePixelRatio || 1);
      // NetInfo downlink is capped/absent in common browsers: it is not a throughput promise.
      // Attempt one visible PDP master, with slow-network veto and progress-based fallback.
      var slowConnection = connection && (connection.saveData || /^(slow-2g|2g|3g)$/.test(connection.effectiveType || ''));
      var useOriginal = opts.allowOriginal !== false && master && width > standardWidth && height > 0 && codec &&
        video.canPlayType('video/mp4; codecs="' + codec + '"') && !slowConnection &&
        innerWidth >= 1000 && matchMedia('(pointer: fine)').matches && neededWidth > standardWidth * 1.2 &&
        (!activeOriginal || activeOriginal === video);
      setSource(useOriginal ? master : standard.url, Boolean(useOriginal));
    }
    listen('loadedmetadata', function () { if (resumeAt > 0 && Number.isFinite(video.duration)) { try { video.currentTime = Math.min(resumeAt, Math.max(0, video.duration - .05)); } catch (_) {} resumeAt = 0; } });
    listen('play', function () { if (original) { if (activeOriginal && activeOriginal !== video) fallback(); else activeOriginal = video; } });
    listen('playing', function () { pending = false; watch(); });
    listen('timeupdate', watch);
    listen('waiting', watch);
    listen('stalled', watch);
    listen('pause', stop);
    listen('error', function () { if (original) fallback(); });
    var api = {
      prepare: prepare,
      start: function () {
        prepare();
        var currentConnection = navigator.connection;
        var restrictedNow = currentConnection && (currentConnection.saveData || /^(slow-2g|2g|3g)$/.test(currentConnection.effectiveType || ''));
        if (original && standard && (restrictedNow || innerWidth < 1000 || !matchMedia('(pointer: fine)').matches)) {
          failed = true; setSource(standard.url, false);
        }
        if (original) {
          if (activeOriginal && activeOriginal !== video && standard) { failed = true; setSource(standard.url, false); }
          else activeOriginal = video;
        }
        pending = true; watch();
      },
      pause: stop,
      isFallingBack: function () { return fallingBack; },
      consumeSourcePause: function () { var value = sourcePausePending; sourcePausePending = false; return value; },
      destroy: function () { disposed = true; generation++; stop(); listeners.forEach(function (x) { video.removeEventListener(x[0], x[1]); }); states.delete(video); }
    };
    states.set(video, api);
    return api;
  }
  window.csDonnaVideoQuality = { attach: attach };
})();

/* ==========================================================================================================
   CONSIGLIERI DONNA · pagina de produs (product.donna) — v2.1 · 07.09.2026
   Progressive enhancement peste markup-ul complet randat de Liquid:
     1. slotul lateral al filmului (≥ 1000 px): un singur element <video-media>, mutat între celula caruselului
        și slot; fără JS, slide-ul rămâne în carusel, slotul nu se afișează;
     2. control play/pause discret; autoplay mut + buclă când filmul intră în ecran (setarea video_autoplay, prin
        controlerul acestei pagini); pauză la ieșirea din viewport și la ascunderea tab-ului, reluare la
        revenire dacă filmul e încă în ecran; pauză la schimbarea slide-ului; pauza cerută de utilizator persistă
        (inclusiv la schimbarea de breakpoint, când componenta nativă ar relua singură); posterul rămâne vizibil
        până la primul cadru decodat (data-dn-frame);
     3. CTA → formularul paginii (ancoră reală), focus pe titlu fără scroll suplimentar;
     4. CTA persistent pe mobil (ascuns când CTA-ul principal, formularul sau footerul sunt vizibile, sau când
        galeria este deschisă în lightbox);
     5. linia de context „Inspirația ta: …” în formular — vizuală, în afara oricărui câmp (nu intră în payload).
   Idempotent: inițializare per secțiune, cleanup la shopify:section:unload, reinițializare la shopify:section:load;
   formularul și footerul sunt rezolvate la fiecare relegare (Theme Editor le poate înlocui separat — R2, review 07.09).
   Fără listener global pe touchmove/wheel. Nu atinge cs-lead-submit.js / cs-attribution.js.
   ========================================================================================================== */
(function () {
  'use strict';
  var instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;
    var handlers = [];
    var on = function (el, ev, fn, opts) {
      if (!el) return;
      el.addEventListener(ev, fn, opts);
      handlers.push(function () { el.removeEventListener(ev, fn, opts); });
    };
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 1000px)');
    var mobile = window.matchMedia('(max-width: 760px)');

    /* ---- 1 · filmul: celulă ↔ slot lateral --------------------------------------------------------- */
    var gallery = root.querySelector('[data-dn-gallery]');
    var cell = root.querySelector('[data-dn-primary-video]');
    var slot = root.querySelector('[data-dn-film-slot]');
    var film = root.querySelector('[data-dn-film]');
    var control = root.querySelector('[data-dn-film-control]');
    var thumb = root.querySelector('[data-dn-primary-video-thumb]');
    var dot = root.querySelector('[data-dn-primary-video-dot]');
    var carousel = gallery ? gallery.querySelector('.product-gallery__carousel') : null;
    var inSlot = false, playRequested = false;
    var primaryQuality = null;
    // Remove only Prestige's own one-shot click handler; other click listeners and bubbling remain intact.
    var ownFilmClick = function () { if (film && typeof film.play === 'function') film.removeEventListener('click', film.play); };

    var pauseFilm = function () {
      playRequested = false;
      primaryQuality?.pause();
      if (!film) return;
      try { if (film.hasAttribute('playing')) film.pause(); } catch (e) { /* player neinițializat */ }
      var v = film.querySelector('video');
      if (v && !v.paused) { try { v.pause(); } catch (e) { /* ignorat */ } }
    };

    var placeFilm = function () {
      if (!film || !cell || !slot || !gallery) return;
      var wantSlot = desktop.matches;
      if (wantSlot === inSlot) return;
      pauseFilm();
      var selected = carousel ? carousel.selectedCell : null;
      var reselect = function () {
        if (!carousel || typeof carousel.select !== 'function') return;
        var idx = selected ? carousel.cells.indexOf(selected) : -1;
        try { carousel.select(idx >= 0 ? idx : 0, { instant: true }); } catch (e) { /* ignorat */ }
      };
      if (wantSlot) {
        slot.appendChild(film);
        if (control) slot.appendChild(control);
        slot.hidden = false;
        cell.setAttribute('hidden', '');
        if (thumb) thumb.setAttribute('hidden', '');
        if (dot) dot.setAttribute('hidden', '');
        gallery.setAttribute('data-dn-film-active', '');
      } else {
        cell.insertBefore(film, cell.firstChild);
        if (control) cell.appendChild(control);
        cell.removeAttribute('hidden');
        if (thumb) thumb.removeAttribute('hidden');
        if (dot) dot.removeAttribute('hidden');
        slot.hidden = true;
        gallery.removeAttribute('data-dn-film-active');
      }
      inSlot = wantSlot;
      reselect(); ownFilmClick();
    };
    placeFilm();
    on(desktop, 'change', placeFilm);

    /* ---- 2 · play / pause ------------------------------------------------------------------------- */
    if (film && control) {
      var playLabel = root.getAttribute('data-dn-play-label') || 'Play';
      var pauseLabel = root.getAttribute('data-dn-pause-label') || 'Pause';
      var syncControl = function () {
        var playing = film.hasAttribute('playing');
        control.setAttribute('data-state', playing ? 'playing' : 'paused');
        control.setAttribute('aria-label', playing ? pauseLabel : playLabel);
      };
      var autoplay = film.hasAttribute('data-dn-autoplay');
      var connection = navigator.connection;
      var userPaused = false, userStarted = false, filmInView = false;
      var pendingSelection = false, selectionSettled = false, selectionFrame = 0;
      var visibleFilmRatio = function () {
        var rect = film.getBoundingClientRect();
        if (!(rect.width > 0 && rect.height > 0)) return 0;
        var left = Math.max(0, rect.left), right = Math.min(innerWidth, rect.right);
        var top = Math.max(0, rect.top), bottom = Math.min(innerHeight, rect.bottom);
        for (var parent = film.parentElement; parent && parent !== document.documentElement; parent = parent.parentElement) {
          var style = getComputedStyle(parent), bounds = parent.getBoundingClientRect();
          if (/^(auto|scroll|hidden|clip)$/.test(style.overflowX || style.overflow)) {
            left = Math.max(left, bounds.left); right = Math.min(right, bounds.right);
          }
          if (/^(auto|scroll|hidden|clip)$/.test(style.overflowY || style.overflow)) {
            top = Math.max(top, bounds.top); bottom = Math.min(bottom, bounds.bottom);
          }
        }
        return Math.max(0, right - left) * Math.max(0, bottom - top) / (rect.width * rect.height);
      };
      var clearSelection = function () {
        pendingSelection = false; selectionSettled = false;
        if (selectionFrame) cancelAnimationFrame(selectionFrame);
        selectionFrame = 0;
      };
      handlers.push(clearSelection);
      var allowed = function () { return filmInView && !document.hidden && film.isConnected && !userPaused && (userStarted || (autoplay && !reduced.matches && !connection?.saveData)); };
      var tryPlay = function () {
        if (!allowed()) { pauseFilm(); return; }
        primaryQuality?.prepare();
        var changed = false;
        film.querySelectorAll('[data-dn-src]').forEach(function (source) { source.src = source.dataset.dnSrc; delete source.dataset.dnSrc; changed = true; });
        if (changed) film.querySelector('video')?.load();
        if (!film.hasAttribute('playing') && !playRequested) {
          playRequested = true;
          primaryQuality?.start();
          try { film.play(); } catch (e) { primaryQuality?.pause(); playRequested = false; }
        }
      };
      var playPendingSelection = function () {
        if (!pendingSelection || !selectionSettled || !film.isConnected || document.hidden) return;
        if (!inSlot && carousel && carousel.selectedCell !== cell) return;
        filmInView = visibleFilmRatio() >= .2;
        if (!filmInView) return;
        clearSelection(); userPaused = false; userStarted = true;
        tryPlay();
        return true;
      };
      var selectFilmExplicitly = function () {
        clearSelection(); pendingSelection = true; playRequested = false;
        selectionFrame = requestAnimationFrame(function () {
          selectionFrame = 0;
          if (carousel) {
            if (carousel.selectedCell !== cell) return;
            var bounds = carousel.getBoundingClientRect(), selected = cell.getBoundingClientRect();
            if (Math.abs(selected.left + selected.width / 2 - bounds.left - bounds.width / 2) > 1) return;
          }
          selectionSettled = true; playPendingSelection();
        });
      };
      on(thumb, 'click', selectFilmExplicitly, true);
      on(dot, 'click', selectFilmExplicitly, true);
      on(carousel, 'carousel:select', function (event) {
        if (event.detail.cell !== cell) clearSelection();
      });
      on(carousel, 'carousel:settle', function (event) {
        if (event.detail.cell !== cell) { clearSelection(); return; }
        if (pendingSelection) { selectionSettled = true; playPendingSelection(); }
      });
      var toggleFilm = function () {
        clearSelection(); playRequested = false;
        if (film.hasAttribute('playing')) { userPaused = true; pauseFilm(); }
        else {
          userPaused = false; userStarted = true;
          filmInView = visibleFilmRatio() >= .2;
          tryPlay();
        }
      };
      on(control, 'click', function (event) { event.preventDefault(); event.stopPropagation(); toggleFilm(); });
      ownFilmClick();
      if (window.customElements) customElements.whenDefined('video-media').then(function () { if (film.isConnected) ownFilmClick(); });
      on(film, 'click', function () { toggleFilm(); });
      on(film, 'media:play', function () { playRequested = false; if (!allowed()) { pauseFilm(); return; } syncControl(); });
      on(film, 'media:pause', function () { playRequested = false; syncControl(); });
      syncControl();
      /* posterul rămâne vizibil până la primul cadru decodat (CSS: .dn-film[loaded]:not([data-dn-frame]) > img) */
      var video = film.querySelector('video');
      primaryQuality = window.csDonnaVideoQuality.attach(video, {
        canRetry: allowed,
        beforeSwitch: function () { playRequested = false; film.removeAttribute('data-dn-frame'); },
        retry: function () { playRequested = false; tryPlay(); },
        posterElement: film.querySelector('img')
      });
      if (primaryQuality) handlers.push(function () { primaryQuality.destroy(); });
      var markFrame = function () { film.setAttribute('data-dn-frame', ''); };
      if (video) {
        if (video.readyState >= 2) markFrame();
        on(video, 'loadeddata', markFrame);
        on(video, 'error', function () { playRequested = false; });
      }

      var update = function () { if (playPendingSelection()) return; if (allowed()) tryPlay(); else pauseFilm(); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          filmInView = entries[0].isIntersecting && entries[0].intersectionRatio >= .2; update();
        }, { threshold: [0, .2] });
        io.observe(film); handlers.push(function () { io.disconnect(); });
      } else {
        var measure = function () { var rect = film.getBoundingClientRect(); filmInView = rect.bottom > 0 && rect.top < innerHeight; update(); };
        on(window, 'scroll', measure); on(window, 'resize', measure); measure();
      }
      on(document, 'visibilitychange', update);
      var preferencesChanged = function () { userStarted = false; update(); };
      on(reduced, 'change', preferencesChanged); on(connection, 'change', preferencesChanged);
      on(window, 'pagehide', pauseFilm);
    }

    var nativeMedia = gallery ? Array.from(gallery.querySelectorAll('.product-gallery__media[data-media-type="video"] video-media:not([data-dn-film])')).map(function (media) {
      return { media: media, video: media.querySelector('video'), cell: media.closest('.product-gallery__media'), ratio: 0, userPaused: false, userStarted: false, pausing: false, requested: false };
    }).filter(function (state) { return state.video; }) : [];
    if (nativeMedia.length) {
      var nativeTransition = false, nativeDisposed = false;
      var nativeConnection = navigator.connection;
      var nativeAuto = gallery.hasAttribute('data-dn-media-autoplay');
      var nativeSelected = function (state) {
        return !nativeTransition && (!carousel || (carousel.selectedCell || carousel.querySelector('.is-initial')) === state.cell);
      };
      var nativeVisible = function (state) {
        return !nativeDisposed && state.media.isConnected && !state.cell.hidden && state.ratio >= .2 && !document.hidden && nativeSelected(state);
      };
      var pauseNative = function (state) {
        state.requested = false;
        state.quality?.pause();
        if (!state.video.paused) {
          state.pausing = true;
          state.video.pause();
        }
      };
      var updateNative = function () {
        nativeMedia.forEach(function (state) {
          var allowed = nativeVisible(state) && !state.userPaused && (state.userStarted || (nativeAuto && !reduced.matches && !nativeConnection?.saveData));
          if (!allowed) { pauseNative(state); return; }
          if (!state.video.paused || state.requested || typeof state.media.play !== 'function') return;
          state.quality?.prepare();
          state.requested = true;
          state.quality?.start();
          state.video.muted = true;
          state.video.defaultMuted = true;
          state.media.removeEventListener('click', state.media.play);
          try { state.media.play(); } catch (error) { state.requested = false; }
        });
      };
      nativeMedia.forEach(function (state) {
        state.quality = window.csDonnaVideoQuality.attach(state.video, {
          canRetry: function () { return nativeVisible(state) && !state.userPaused && (state.userStarted || (nativeAuto && !reduced.matches && !nativeConnection?.saveData)); },
          beforeSwitch: function () { state.requested = false; if (!state.video.paused) state.pausing = true; },
          retry: function () { state.requested = false; updateNative(); },
          posterElement: state.media.querySelector('img')
        });
        if (state.quality) handlers.push(function () { state.quality.destroy(); });
        state.video.loop = true;
        state.video.playsInline = true;
        state.video.muted = true;
        state.video.defaultMuted = true;
        on(state.video, 'play', function () {
          if (!state.requested) { state.userStarted = true; state.userPaused = false; }
          state.requested = false;
          state.media.removeEventListener('click', state.media.play);
          if (!nativeVisible(state)) pauseNative(state);
        });
        on(state.video, 'pause', function () {
          if (state.quality?.consumeSourcePause()) { state.pausing = false; return; }
          state.requested = false;
          if (state.pausing) { state.pausing = false; return; }
          if (!state.video.seeking && nativeVisible(state)) state.userPaused = true;
        });
        on(state.video, 'error', function () { state.requested = false; });
      });
      on(gallery, 'media:play', function (event) {
        nativeMedia.forEach(function (state) { if (state.media !== event.target) pauseNative(state); });
      });
      on(carousel, 'carousel:change', function () {
        nativeTransition = true;
        nativeMedia.forEach(pauseNative);
      }, true);
      on(carousel, 'carousel:settle', function () { nativeTransition = false; updateNative(); });
      if ('IntersectionObserver' in window) {
        var nativeObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var state = nativeMedia.find(function (item) { return item.media === entry.target; });
            if (state) state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          });
          updateNative();
        }, { threshold: [0, .2] });
        nativeMedia.forEach(function (state) { nativeObserver.observe(state.media); });
        handlers.push(function () { nativeObserver.disconnect(); });
      } else {
        var measureNative = function () {
          nativeMedia.forEach(function (state) {
            var bounds = state.media.getBoundingClientRect();
            var left = Math.max(0, bounds.left), right = Math.min(innerWidth, bounds.right);
            var top = Math.max(0, bounds.top), bottom = Math.min(innerHeight, bounds.bottom);
            state.ratio = bounds.width && bounds.height ? Math.max(0, right - left) * Math.max(0, bottom - top) / (bounds.width * bounds.height) : 0;
          });
          updateNative();
        };
        on(window, 'scroll', measureNative); on(window, 'resize', measureNative); measureNative();
      }
      on(document, 'visibilitychange', updateNative);
      var nativePreferencesChanged = function () { nativeMedia.forEach(function (state) { state.userStarted = false; }); updateNative(); };
      on(reduced, 'change', nativePreferencesChanged); on(nativeConnection, 'change', nativePreferencesChanged);
      var pauseAllNative = function () { nativeMedia.forEach(pauseNative); };
      on(window, 'pagehide', pauseAllNative);
      handlers.push(function () { nativeDisposed = true; pauseAllNative(); });
      if (window.customElements) customElements.whenDefined('video-media').then(updateNative);
    }

    /* ---- 3 · CTA → formular (ținta se rezolvă la fiecare click: formularul poate fi înlocuit în Theme Editor) --- */
    var anchorId = root.getAttribute('data-dn-anchor') || 'donna-appointment';
    var getFormSection = function () {
      var a = document.getElementById(anchorId);
      return a ? (a.closest('.shopify-section') || a) : null;
    };
    var goToForm = function (event) {
      var section = getFormSection();
      if (!section) return; /* fără ancoră pe pagină: linkul rămâne un link normal */
      if (event) event.preventDefault();
      section.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      var heading = section.querySelector('.section-header .h2, .section-header h2, h2, h3');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    };
    document.querySelectorAll('[data-dn-appointment]').forEach(function (link) { on(link, 'click', goToForm); });

    /* ---- 4 · CTA persistent (mobil) ---------------------------------------------------------------- */
    var sticky = document.querySelector('[data-dn-sticky]');
    var ctaBlock = root.querySelector('[data-dn-cta-block]');
    var ctaVisible = true, formVisible = false, footerVisible = false;
    var observedForm = null, observedFooter = null, so = null;
    var overlayOpen = function () {
      /* PhotoSwipe (galeria), dialogurile/drawer-ele Prestige (atribut open) și <dialog> nativ */
      return !!document.querySelector('.pswp--open, .pswp[aria-hidden="false"], dialog-element[open], x-drawer[open], cart-drawer[open], facets-drawer[open], [role="dialog"][open], dialog[open]');
    };
    var updateSticky = function () {
      if (!sticky) return;
      var show = mobile.matches && !ctaVisible && !formVisible && !footerVisible && !overlayOpen();
      /* scrieri doar la schimbare (observatorul de mutații nu trebuie să se auto-declanșeze) */
      if (sticky.hasAttribute('data-visible') !== show) sticky.toggleAttribute('data-visible', show);
      if (sticky.getAttribute('aria-hidden') !== String(!show)) sticky.setAttribute('aria-hidden', String(!show));
      var a = sticky.querySelector('a');
      if (a && a.tabIndex !== (show ? 0 : -1)) a.tabIndex = show ? 0 : -1;
    };
    var scheduledUpdate = 0;
    var scheduleUpdate = function () {
      if (scheduledUpdate) return;
      scheduledUpdate = window.requestAnimationFrame(function () { scheduledUpdate = 0; updateSticky(); });
    };
    if (sticky) {
      so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.target === ctaBlock) ctaVisible = e.isIntersecting;
          if (e.target === observedForm) formVisible = e.isIntersecting;
          if (e.target === observedFooter) footerVisible = e.isIntersecting;
        });
        updateSticky();
      }, { threshold: 0, rootMargin: '0px 0px 30px 0px' });
      if (ctaBlock) so.observe(ctaBlock);
      handlers.push(function () { so.disconnect(); });
      on(mobile, 'change', updateSticky);
      /* evenimentele Prestige nu fac bubbling: ascultare în faza de captură; PhotoSwipe se adaugă/elimină din body */
      ['lightbox:open', 'dialog:before-show', 'dialog:after-show', 'dialog:after-hide'].forEach(function (ev) { on(document, ev, scheduleUpdate, true); });
      var mo = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (!sticky.contains(records[i].target)) { scheduleUpdate(); return; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden'] });
      handlers.push(function () { mo.disconnect(); if (scheduledUpdate) window.cancelAnimationFrame(scheduledUpdate); });
    }

    /* ---- 5 · legarea formularului: linia de context (vizuală; niciun câmp) + observarea pentru sticky.
              Idempotentă; se reia la orice shopify:section:load/unload (formularul sau footerul pot fi înlocuite). */
    var contextEl = null;
    var bindForm = function () {
      var section = getFormSection();
      var footer = document.querySelector('.shopify-section--footer');
      /* linia de context: exact una, în formularul curent */
      var form = section ? (section.querySelector('form[data-cs-lead-form]') || section.querySelector('form')) : null;
      var title = root.querySelector('.dn-pdp__title');
      var label = root.getAttribute('data-dn-inspiration-label') || '';
      if (contextEl && (!form || contextEl.parentNode !== form)) { if (contextEl.parentNode) contextEl.parentNode.removeChild(contextEl); contextEl = null; }
      if (form && title && label) {
        var existing = form.querySelector('[data-dn-context]');
        if (existing && existing !== contextEl) { if (contextEl && contextEl.parentNode) contextEl.parentNode.removeChild(contextEl); contextEl = existing; }
        if (!contextEl) {
          contextEl = document.createElement('p');
          contextEl.className = 'dn-context';
          contextEl.setAttribute('data-dn-context', '');
          form.insertBefore(contextEl, form.firstChild);
        }
        contextEl.textContent = label + ' ' + title.textContent.trim();
      }
      /* observarea pentru sticky: formularul și footerul curente */
      if (so) {
        if (observedForm !== section) {
          if (observedForm) so.unobserve(observedForm);
          formVisible = false;
          observedForm = section;
          if (section) so.observe(section);
        }
        if (observedFooter !== footer) {
          if (observedFooter) so.unobserve(observedFooter);
          footerVisible = false;
          observedFooter = footer;
          if (footer) so.observe(footer);
        }
      }
      updateSticky();
    };
    bindForm();
    handlers.push(function () { if (contextEl && contextEl.parentNode) contextEl.parentNode.removeChild(contextEl); contextEl = null; });

    instances.set(root, {
      rebind: bindForm,
      cleanup: function () {
        pauseFilm();
        handlers.forEach(function (fn) { fn(); });
        instances.delete(root);
      }
    });
  }

  function initAll() { document.querySelectorAll('[data-dn-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();

  /* Theme Editor: secțiunea principală se reinițializează; orice altă secțiune (formular, footer) reînnoită sau
     eliminată → toate instanțele își releagă formularul și footerul (un singur set de listeners/observers). */
  var rebindAll = function () {
    document.querySelectorAll('[data-dn-pdp]').forEach(function (root) { var inst = instances.get(root); if (inst) inst.rebind(); });
  };
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-dn-pdp]') : null;
    if (root) init(root); else rebindAll();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-dn-pdp]') : null;
    var inst = root ? instances.get(root) : null;
    if (inst) inst.cleanup(); else setTimeout(rebindAll, 0);
  });
})();
